module.exports = __webpack_public_path__ + "static/media/isnamic.5bd4de1d.jpg";